import React from "react";
import { Link } from "react-router-dom";
import { BadgeCheck, MapPin, Heart, Star, Crown } from "lucide-react";

export default function MemberCard({ m, onLike, onFav }) {
  const photo = m.avatar || (m.photos && m.photos[0]) || `https://api.dicebear.com/7.x/thumbs/svg?seed=${m.id}`;
  return (
    <div className="group bg-white rounded-2xl border border-stone-100 shadow-[0_8px_30px_rgb(28,25,23,0.05)] overflow-hidden flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_40px_rgb(28,25,23,0.10)]" data-testid={`member-card-${m.id}`}>
      <Link to={`/members/${m.id}`} className="block relative">
        <div className="aspect-[4/5] overflow-hidden bg-stone-100">
          <img src={photo} alt={m.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        </div>
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/40 to-transparent pointer-events-none" />
        {m.online && (
          <span className="absolute top-3 left-3 flex items-center gap-1.5 bg-white/90 backdrop-blur text-stone-800 text-[11px] font-medium px-2.5 py-1 rounded-full shadow-sm">
            <span className="w-1.5 h-1.5 rounded-full bg-[#10B981]" /> Online
          </span>
        )}
        {m.membership === "premium" && (
          <span className="absolute top-3 right-3 bg-[#D4AF37] text-[#1C1917] p-1.5 rounded-full shadow-sm"><Crown className="w-3.5 h-3.5" /></span>
        )}
      </Link>
      <div className="p-4 flex-1 flex flex-col">
        <div className="flex items-center gap-1.5">
          <h3 className="font-display text-lg font-medium text-stone-900 truncate">{m.name}{m.age ? `, ${m.age}` : ""}</h3>
          {m.verified_badge && <BadgeCheck className="w-4 h-4 text-[#D4AF37] flex-shrink-0" fill="#D4AF37" stroke="#1C1917" />}
        </div>
        {m.location && <p className="text-xs text-stone-500 flex items-center gap-1 mt-0.5"><MapPin className="w-3 h-3" />{m.location}</p>}
        <p className="text-sm text-stone-600 line-clamp-2 mt-2 flex-1 leading-relaxed">{m.bio || "No bio yet."}</p>
        <div className="flex gap-2 mt-4">
          <button onClick={() => onLike?.(m)} data-testid={`like-btn-${m.id}`} className={`flex-1 py-2 rounded-full border transition-all flex items-center justify-center ${m.liked ? "bg-[#8B1E3F] border-[#8B1E3F] text-white" : "bg-white border-stone-200 text-stone-600 hover:border-[#8B1E3F] hover:text-[#8B1E3F]"}`}>
            <Heart className="w-4 h-4" fill={m.liked ? "white" : "none"} />
          </button>
          <button onClick={() => onFav?.(m)} data-testid={`fav-btn-${m.id}`} className={`flex-1 py-2 rounded-full border transition-all flex items-center justify-center ${m.favorited ? "bg-[#D4AF37] border-[#D4AF37] text-[#1C1917]" : "bg-white border-stone-200 text-stone-600 hover:border-[#D4AF37]"}`}>
            <Star className="w-4 h-4" fill={m.favorited ? "#1C1917" : "none"} />
          </button>
        </div>
      </div>
    </div>
  );
}
